// Create a new file for constants
export const QUEUE_TABS = {
  ASSIGNED: "Assigned Tasks",
  UNASSIGNED: "Unassigned Tasks",
  FORMATION: "Formation Request"
}; 

export const SOCKET_EVENTS = {
  TAX_RETURN_STATUS: "tax_return_status",
  WElCOME_ONBOARD: "welcome_onboard",
};